import config from '../config'

export default config.appEnv === 'staging'
